import { call, take, put, fork, all, select } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { cookies } from 'src/utils';
import { fetchJson } from 'src/utils/fetch';
import format from 'src/utils/format';
import { aesDecrypt } from 'src/utils/tool';
import { initialState } from './reducer';
import { PatientsActionTypes } from './type';

function* fetch_patient_list() {
  while (true) {
    const action = yield take(PatientsActionTypes.FETCH_PATIENT_LIST);
    const { data = {}, onSuccess } = action || {};
    try {
      const res = yield call(fetchJson, { url: '/api/api/v1/patient/patient/list', type: 'POST', action, data });
      if (res && res.code === '0') {
        const { result = [] } = res;
        const { option: { needSensitiveEncrypt = false } = {}, sensitiveKeyEncry = '' } = data;
        result.length &&
          result.forEach((element) => {
            let { patientCertNo, patientBirthday, patientCertType} = element;
            if(needSensitiveEncrypt && sensitiveKeyEncry){
              patientCertNo = aesDecrypt(element.patientCertNo);
            }
            const year = patientCertNo.substring(6,10);
            const month = patientCertNo.substring(10,12);
            const day = patientCertNo.substring(12,14);
            const birthDay = patientCertType === 'I' ? `${year}-${month}-${day}` : patientBirthday;
            element.age = format.GetAgeByBirthday(birthDay) || '';  // 这里不从patientBirthDay取了，前端自己从证件号取
            element.patientPhone_copy = element.patientPhone;
          });
        let patientList = result.sort((i, v) => i.patientRelation - v.patientRelation);
        if (needSensitiveEncrypt && sensitiveKeyEncry) {
          // patientName、patientCertNo、patientPhone
          patientList = patientList.map((k) => ({
            ...k,
            patientName: aesDecrypt(k.patientName),
            patientCertNo: aesDecrypt(k.patientCertNo),
            patientPhone: aesDecrypt(k.patientPhone),
          }));
        }
        onSuccess && onSuccess(patientList);
        yield put({ type: PatientsActionTypes.FETCH_PATIENT_LIST_SUCCESS, data: patientList });
      }
    } catch (error) {
      // Sentry.captureException(error);
      console.log(error, 'err');
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_patient_list--------' + error.message);
    }
  }
}

function* fetch_patient_inquiry() {
  while (true) {
    const action = yield take(PatientsActionTypes.FETCH_PATIENT_INQUIRY);
    try {
      const { patientId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/inquiry/list',
        type: 'POST',
        action,
        data: {
          patientId,
          inquiryStatusList: [3, 4, 5, 10, 11],
          option: {
            needStaff: true,
          },
          inquiryTypes: ['I', 'V'],
          // inquiryType: 'I',
        },
      });
      if (res && res.code === '0') {
        const data: any = [];
        const { result = [] } = res;
        result.length &&
          result.forEach((element) => {
            const obj = {
              id: element.id,
              inquiryTime: element.inquiryTime,
              illnessDescription: element.illnessDescription,
              staffName: element.medicalStaff.staffName,
              workDepartment: element.medicalStaff.workDepartment,
              staffProfessionalTitle: element.medicalStaff.staffProfessionalTitle,
            };
            data.push(obj);
          });
        yield put({ type: PatientsActionTypes.FETCH_PATIENT_INQUIRY_SUCCESS, data });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_patient_inquiry--------' + error.message);
    }
  }
}

function* fetch_patient_no() {
  while (true) {
    const action = yield take(PatientsActionTypes.FETCH_PATIENT_NO);
    try {
      const {
        patients: { editPatient },
      } = yield select();
      if (editPatient.patientNo && editPatient.patientNo !== '') {
        return;
      }
      const res = yield call(fetchJson, { url: '/api/api/v1/patient/bizno/getByType', type: 'POST', isloading: false, action, data: { bizNoType: 'PATIENT_NO' } });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: PatientsActionTypes.FETCH_PATIENT_NO_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_patient_no--------' + error.message);
    }
  }
}

function* fetch_patient_detail() {
  while (true) {
    const action = yield take(PatientsActionTypes.FETCH_PATIENT_DETAIL);
    try {
      const { onSuccess, patientId, option } = action;
      const res = yield call(fetchJson, { url: '/api/api/v1/patient/patient/detail', type: 'POST', data: { patientId, option }, action });
      if (res && res.code === '0') {
        const { result = {} } = res;
        const data = {
          ...initialState.editPatient,
          ...result,
          patientDistrictCode: res.result.patientDistrictCode && res.result.patientDistrictCode.split('-').map((i) => parseInt(i, 10)),
        };

        yield put({ type: PatientsActionTypes.FETCH_PATIENT_DETAIL_SUCCESS, data });
        typeof onSuccess === 'function' && onSuccess(data);
      }
    } catch (error) {
      console.error(error, '网络异常，请稍后重试');
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_patient_detail--------' + error.message);
    }
  }
}

function* save_patient() {
  while (true) {
    const action = yield take(PatientsActionTypes.SAVE_PATIENT);
    try {
      const { onSuccess, needToast = true } = action;
      const {
        patients: { editPatient },
      } = yield select();
      if (!editPatient.patientName) {
        StaticToast.warning('请重新编辑患者信息');
      } else {
        console.log('editPatient', editPatient);
        const data = {
          ...editPatient,
          patientDistrictCode:
            Array.isArray(editPatient.patientDistrictCode) ? editPatient.patientDistrictCode.join('-') : undefined,
        };

        const res: any = yield call(fetchJson, { url: `/api/api/v1/patient/patient/${editPatient.id ? 'modify2' : 'save'}`, type: 'POST', data, action });
        if (res && res.code === '0') {
          const { patientRelation = '' } = data;
          needToast && StaticToast.success('保存成功', 1500);
          patientRelation == 1 && cookies.set('isRealAuth', 'Y');
          setTimeout(() => {
            // 将保存成功的患者数据传递给回调
            const savedPatientData = {
              ...editPatient,
              ...data,
              id: res.result || editPatient.id, // 新增患者时从响应中获取ID
            };
            typeof onSuccess === 'function' && onSuccess(editPatient.backUrl, savedPatientData);
          }, 1500);
          // yield put({ type: PatientsActionTypes.CLEAR_PATIENT });
        }
      }
    } catch (error) {
      console.error(error);
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* delete_patient() {
  while (true) {
    const action = yield take(PatientsActionTypes.DELETE_PATIENT);
    try {
      const { patientId, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/patient/delete',
        type: 'GET',
        data: {
          patientId,
        },
      });
      if (res && res.code === '0') {
        StaticToast.success('患者删除成功');
        typeof onSuccess === 'function' && onSuccess();
        yield put({ type: PatientsActionTypes.FETCH_PATIENT_LIST });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('delete_patient--------' + error.message);
    }
  }
}

function* uploadFile() {
  while (true) {
    const action = yield take(PatientsActionTypes.UPLOAD_FILE);
    try {
      const { formData, attachmentType } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/attchment/upload',
        type: 'UPLOAD',
        isloading: true,
        data: formData,
        action,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        const data = {
          ...result[0],
          attachmentType,
        };
        yield put({ type: PatientsActionTypes.UPLOAD_FILE_SUCCESS, data });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('uploadFile--------' + error.message);
    }
  }
}

export default function* root() {
  yield all([fork(fetch_patient_list), fork(fetch_patient_no), fork(fetch_patient_detail), fork(save_patient), fork(uploadFile), fork(fetch_patient_inquiry), fork(delete_patient)]);
}
